import React, { useState, useRef, useEffect, useMemo } from "react";
import SignatureCanvas from "react-signature-canvas";

const COMPONENTES_AUDITORIA = [
  {
    nombre: "A. Bases y apertura de caja",
    items: [
      { n: 1, criterio: "La base de caja asignada a cada cajero está registrada y coincide con el valor físico entregado.", evidencia: "Formato/registro de entrega de base" },
      { n: 2, criterio: "La entrega de bases se realiza individualmente y queda identificada por cajero y turno.", evidencia: "Registro de bases / soporte firmado" },
      { n: 3, criterio: "Se realiza el arqueo inicial y se conserva evidencia del valor de apertura.", evidencia: "Arqueo inicial / reporte del sistema" },
      { n: 4, criterio: "Los puntos de pago cuentan con datáfono, impresora, sistema POS e insumos requeridos para la operación.", evidencia: "Verificación física / novedad reportada" }
    ]
  },
  {
    nombre: "B. Arqueos y manejo de efectivo",
    items: [
      { n: 5, criterio: "El efectivo físico coincide con el valor esperado según sistema al momento del arqueo.", evidencia: "Arqueo físico / reporte POS" },
      { n: 6, criterio: "Los faltantes o sobrantes están identificados, justificados y reportados oportunamente.", evidencia: "Reporte de novedad / soporte" },
      { n: 7, criterio: "Los arqueos, reportes y soportes no presentan alteraciones o correcciones no autorizadas.", evidencia: "Arqueo / soportes físicos y digitales" },
      { n: 8, criterio: "Los cambios de turno incluyen conteo y entrega de efectivo y demás medios de pago.", evidencia: "Arqueo de cambio de turno" }
    ]
  },
  {
    nombre: "C. Medios de pago",
    items: [
      { n: 9, criterio: "Los pagos con tarjeta coinciden con cierres de datáfono y reportes del sistema.", evidencia: "Cierre detallado de datáfono / POS" },
      { n: 10, criterio: "Las transferencias están plenamente identificadas, son legibles y corresponden al valor de la compra.", evidencia: "Comprobante de transferencia / factura" },
      { n: 11, criterio: "Bonos u otros medios autorizados cuentan con soportes completos y están correctamente registrados.", evidencia: "Bonos / reportes POS" },
      { n: 12, criterio: "Las transacciones rechazadas, duplicadas o con novedad tienen tratamiento y soporte correspondiente.", evidencia: "Reporte de novedad / evidencia" }
    ]
  },
  {
    nombre: "D. Devoluciones, anulaciones y cruces",
    items: [
      { n: 13, criterio: "Las devoluciones cumplen el procedimiento y cuentan con factura, motivo, datos y autorización requeridos.", evidencia: "Factura / formato / soporte devolución" },
      { n: 14, criterio: "Las anulaciones están justificadas y cuentan con autorización y trazabilidad en el sistema.", evidencia: "Reporte POS / autorización" },
      { n: 15, criterio: "Las transferencias duplicadas cuentan con Formato de Buena Fe y requisición de devolución cuando aplica.", evidencia: "Formatos / factura / evidencia" },
      { n: 16, criterio: "Los cruces de dinero están soportados y corresponden al valor, factura y medio de pago correctos.", evidencia: "Reporte administrativo / factura" }
    ]
  },
  {
    nombre: "E. Cierres y soportes de Tesorería",
    items: [
      { n: 17, criterio: "Se realizan cierres parciales y finales verificando efectivo y todos los medios de pago.", evidencia: "Cierre de caja / arqueo final" },
      { n: 18, criterio: "El efectivo entregado está contado, organizado y relacionado con el cierre de caja.", evidencia: "Arqueo / entrega de efectivo" },
      { n: 19, criterio: "Los vouchers de tarjetas están enumerados y totalizados.", evidencia: "Vouchers / cierre de datáfono" },
      { n: 20, criterio: "El cierre detallado de datáfono está anexado y las diferencias están justificadas.", evidencia: "Cierre datáfono / justificación" },
      { n: 21, criterio: "Bonos, transferencias, devoluciones y demás soportes están organizados junto con el arqueo final.", evidencia: "Paquete documental de cierre" },
      { n: 22, criterio: "Los soportes enviados a Tesorería están completos, legibles, organizados y debidamente justificados.", evidencia: "Documentación entregada a Tesorería" }
    ]
  },
  {
    nombre: "F. Cumplimiento de cajeros y coordinación",
    items: [
      { n: 23, criterio: "Los cajeros aplican correctamente los procedimientos de caja, facturación y medios de pago.", evidencia: "Observación / prueba verbal o escrita" },
      { n: 24, criterio: "El Coordinador Administrativo supervisa bases, arqueos, cambios de turno y cierres conforme al procedimiento.", evidencia: "Registros / observación directa" },
      { n: 25, criterio: "Se documentan y reportan hallazgos, novedades e inconsistencias al nivel correspondiente.", evidencia: "Reportes / correos / formatos" },
      { n: 26, criterio: "Se mantiene confidencialidad y custodia adecuada de dinero, información financiera y soportes.", evidencia: "Observación / controles de acceso" }
    ]
  },
  {
    nombre: "G. Seguimiento a auditorías",
    items: [
      { n: 27, criterio: "Los hallazgos de auditorías anteriores cuentan con plan de acción y responsable definido.", evidencia: "Plan de acción anterior" },
      { n: 28, criterio: "Las acciones correctivas vencidas han sido cerradas con evidencia suficiente.", evidencia: "Evidencia de cierre" },
      { n: 29, criterio: "Los hallazgos recurrentes se encuentran escalados y tienen seguimiento documentado.", evidencia: "Informe / seguimiento" },
      { n: 30, criterio: "La evidencia de la auditoría queda organizada y disponible para consulta y trazabilidad.", evidencia: "Carpeta / informe de auditoría" }
    ]
  },
  {
    nombre: "H. Evaluación de códigos y dotación",
    items: [
      { n: 31, criterio: "Se audita y verifica correctamente cómo el Administrador realiza el cierre y el arqueo de códigos.", evidencia: "Registro de cierre / arqueo de códigos" },
      { n: 32, criterio: "Se garantiza el conteo físico, la validación y el reporte transparente de la auditoría.", evidencia: "Reporte de auditoría de códigos" },
      { n: 33, criterio: "Se cumple rigurosamente con los estándares de dotación y presentación personal establecidos.", evidencia: "Verificación visual de dotación" },
      { n: 34, criterio: "Los hallazgos de dotación y códigos están debidamente registrados con nombre, detalle e información de lo encontrado.", evidencia: "Formato de novedad / hallazgo" }
    ]
  }
];

export default function FormatoAuditoriaTesoreria({ usuario, onBack }) {
  const firmaRef = useRef(null);
  const firmaAdminRef = useRef(null); 
  const auditorNombre = `${usuario?.nombres || ""} ${usuario?.apellidos || ""}`.trim();

  const [sedesDisponibles, setSedesDisponibles] = useState([]);
  const permisosABAC = useMemo(() => {
    try {
      const parsed = typeof usuario?.permisos_avanzados === 'string' ? JSON.parse(usuario.permisos_avanzados) : (usuario?.permisos_avanzados || {});
      return parsed.micros || parsed; 
    } catch (e) { return {}; }
  }, [usuario]);

  const [toastMsg, setToastMsg] = useState({ text: "", type: "" });
  const [modalConfirmacion, setModalConfirmacion] = useState(false);
  const [alertaExito, setAlertaExito] = useState(false);

  const [headerData, setHeaderData] = useState({
    fecha: new Date().toISOString().split('T')[0],
    tipo: "Programada",
    puntoVenta: "", 
    codigoBodega: "",
    adminPDV: "",
    coordAdmin: "",
    horaInicio: new Date().toTimeString().split(' ')[0].substring(0, 5),
    horaFin: ""
  });

  const [respuestas, setRespuestas] = useState({});
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    const fetchSedes = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/sedes`);
        const data = await res.json();
        if (data.success) {
          const cargoUpper = String(usuario?.cargo || "").toUpperCase();
          const esAdminGlobal = cargoUpper === "SUPER_ADMIN";
          const configPermiso = permisosABAC['Lista de Chequeo FT-AI-01'] || {};
          const alcance = configPermiso.alcance || "PROPIA";
          const sedesEspecificas = configPermiso.sedes_ids || [];

          let filtradas = data.sedes;
          if (!esAdminGlobal && alcance !== "GLOBAL") {
            if (alcance === "ESPECIFICA" && sedesEspecificas.length > 0) {
              filtradas = data.sedes.filter(s => sedesEspecificas.includes(String(s.id)) || sedesEspecificas.includes(String(s.codigo_bodega)));
            } else {
              filtradas = data.sedes.filter(s => String(s.codigo_bodega) === String(usuario?.codigo_bodega || usuario?.sede_id));
            }
          }
          setSedesDisponibles(filtradas);

          if (filtradas.length === 1) {
            setHeaderData(prev => ({ ...prev, puntoVenta: filtradas[0].nombre, codigoBodega: filtradas[0].codigo_bodega }));
          }
        }
      } catch(e) { console.error("Error al cargar sedes:", e); }
    };
    fetchSedes();
  }, [usuario, permisosABAC]);

  const handleHeaderChange = (e) => {
    const { name, value } = e.target;
    if (name === "puntoVenta") {
      const sedeSeleccionada = sedesDisponibles.find(s => s.nombre === value);
      setHeaderData({ ...headerData, puntoVenta: value, codigoBodega: sedeSeleccionada ? sedeSeleccionada.codigo_bodega : "" });
    } else {
      setHeaderData({ ...headerData, [name]: value });
    }
  };

  const handleRespuestaChange = (n, campo, valor) => {
    setRespuestas(prev => ({
      ...prev,
      [n]: { ...prev[n], [campo]: valor }
    }));
  };

  const showToastError = (text) => {
    setToastMsg({ text, type: "error" });
    setTimeout(() => setToastMsg({ text: "", type: "" }), 3500);
  };

  const ejecutarLlenadoRapido = () => {
    const nuevasRespuestas = { ...respuestas };
    COMPONENTES_AUDITORIA.forEach(comp => {
      comp.items.forEach(item => {
        if (!nuevasRespuestas[item.n]) nuevasRespuestas[item.n] = {};
        nuevasRespuestas[item.n].resultado = "CUMPLE";
      });
    });
    setRespuestas(nuevasRespuestas);
    setModalConfirmacion(false);
  };

  const limpiarFirma = (ref) => {
    try {
      if (ref.current && typeof ref.current.clear === 'function') {
        ref.current.clear();
      }
    } catch (error) {
      console.error("Error al limpiar la firma:", error);
    }
  };

  const calcularScore = () => {
    let cumple = 0, noCumple = 0, na = 0;
    Object.values(respuestas).forEach(r => {
      if (r.resultado === "CUMPLE") cumple++;
      if (r.resultado === "NO CUMPLE") noCumple++;
      if (r.resultado === "N/A") na++;
    });
    const totalAplicables = cumple + noCumple;
    const porcentaje = totalAplicables === 0 ? 0 : Math.round((cumple / totalAplicables) * 100);
    return { cumple, noCumple, na, porcentaje };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (Object.keys(respuestas).length < 34) {
      showToastError("⚠️ Faltan ítems por calificar en la lista de chequeo.");
      return;
    }
    if (!headerData.codigoBodega) {
      showToastError("⚠️ Debes seleccionar la Sede / Punto de Venta.");
      return;
    }
    if (firmaRef.current && firmaRef.current.isEmpty()) {
      showToastError("⚠️ El Auditor debe firmar el documento antes de guardar.");
      return;
    }
    if (firmaAdminRef.current && firmaAdminRef.current.isEmpty()) {
      showToastError("⚠️ El Administrador de Punto debe firmar el documento antes de guardar.");
      return;
    }
    
    setGuardando(true);
    
    try {
      const getCanvasBase64 = (ref) => {
        try {
          const canvas = ref.current.getTrimmedCanvas();
          return canvas ? canvas.toDataURL('image/png') : "";
        } catch (err) {
          const normal = ref.current.getCanvas();
          return normal ? normal.toDataURL('image/png') : "";
        }
      };

      const firmaBase64 = getCanvasBase64(firmaRef);
      const firmaAdminBase64 = getCanvasBase64(firmaAdminRef);
      
      const payload = {
        fecha_auditoria: headerData.fecha,
        hora_auditoria: headerData.horaInicio,
        codigo_bodega: headerData.codigoBodega,
        auditor: auditorNombre,
        tipo_auditoria: headerData.tipo,
        observaciones: `Admin PDV: ${headerData.adminPDV}\nCoord. Administrativo: ${headerData.coordAdmin}\nTotal Puntos CUMPLE: ${calcularScore().cumple}\nTotal Puntos NO CUMPLE: ${calcularScore().noCumple}`,
        estado: calcularScore().noCumple > 0 ? 'CON HALLAZGOS' : 'CERRADO',
        firma_auditor: firmaBase64,
        firma_admin: firmaAdminBase64, 
        respuestas_detalle: respuestas 
      };

      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/auditoria-tesoreria`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
      const data = await res.json();
      
      if (data.success) {
        setAlertaExito(true); 
        setTimeout(onBack, 3000);
      } else {
        showToastError(data.message || "Error al guardar la auditoría.");
        setGuardando(false);
      }
    } catch (error) {
      showToastError("Error de conexión al servidor.");
      setGuardando(false);
    }
  };

  const score = calcularScore();
  const inputClass = "w-full h-10 px-3 bg-white/70 border border-white/90 rounded-xl text-xs font-bold text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-400 shadow-inner box-border transition-all";

  return (
    <div className="w-full min-h-screen py-6 px-4 flex flex-col items-center animate-fade-in relative z-10">
      
      {toastMsg.text && (
        <div className="fixed top-6 left-1/2 -translate-x-1/2 z-[9999] px-6 py-3 rounded-full text-xs font-bold shadow-2xl flex items-center gap-3 animate-fade-in-up bg-red-600/95 backdrop-blur-md text-white border border-red-500">
          <span>{toastMsg.text}</span>
          <button onClick={() => setToastMsg({text:'', type:''})} className="text-white/80 hover:text-white cursor-pointer">✕</button>
        </div>
      )}

      {alertaExito && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-900/60 backdrop-blur-md p-4 animate-fade-in">
          <div className="bg-white/80 backdrop-blur-3xl rounded-[32px] p-10 shadow-2xl w-full max-w-sm border border-white text-center animate-scale-in flex flex-col items-center">
            <div className="w-24 h-24 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center text-5xl mb-6 shadow-sm border border-emerald-200">✨</div>
            <h3 className="text-2xl font-black text-gray-900 mb-2 tracking-tight">¡Guardado Exitoso!</h3>
            <p className="text-sm text-gray-600 font-medium mb-6 leading-relaxed">La lista de chequeo ha sido firmada y registrada correctamente en el sistema.</p>
            <div className="w-20 h-1.5 bg-emerald-500 rounded-full animate-pulse shadow-sm"></div>
            <p className="text-[10px] text-gray-400 mt-4 font-bold uppercase tracking-wider">Regresando al menú...</p>
          </div>
        </div>
      )}

      {modalConfirmacion && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-900/40 backdrop-blur-md p-4 animate-fade-in">
          <div className="bg-white/70 backdrop-blur-3xl rounded-[32px] p-8 shadow-2xl w-full max-w-sm border border-white/80 text-center animate-scale-in">
            <h3 className="text-xl font-black text-gray-900 mb-2">¿Llenado Rápido?</h3>
            <p className="text-xs text-gray-600 font-medium mb-8 leading-relaxed">Esta acción marcará los 30 ítems como <strong className="text-emerald-700 font-black">CUMPLE</strong>. Podrás modificar individualmente los hallazgos después.</p>
            <div className="flex flex-col gap-3">
              <button onClick={ejecutarLlenadoRapido} className="w-full py-3 bg-[#007aff] hover:bg-[#005bb5] text-white text-xs font-black uppercase tracking-wider rounded-xl transition-all shadow-md cursor-pointer">Sí, Llenar Todo</button>
              <button onClick={() => setModalConfirmacion(false)} className="w-full py-3 bg-white hover:bg-gray-50 text-gray-700 border border-gray-200 text-xs font-bold uppercase tracking-wider rounded-xl transition-all shadow-sm cursor-pointer">Cancelar</button>
            </div>
          </div>
        </div>
      )}

      <div className="bg-white/50 backdrop-blur-[45px] rounded-[34px] shadow-[0_25px_70px_rgba(0,0,0,0.15)] p-4 sm:p-8 max-w-7xl w-full mx-auto h-[90vh] overflow-y-auto border border-white/80 custom-scrollbar text-gray-900">
        
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center border-b border-gray-900/10 pb-4 mb-6 gap-4 sticky top-0 bg-white/80 backdrop-blur-md z-20 -mx-4 px-4 sm:-mx-8 sm:px-8 py-4 rounded-b-3xl shadow-sm">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-xl bg-blue-600/10 border border-blue-500/20 flex items-center justify-center text-2xl shadow-inner">📝</div>
            <div>
              <h2 className="text-lg sm:text-xl font-black tracking-tight text-gray-900 leading-tight">Lista de Chequeo de Auditoría Interna</h2>
              <p className="text-[10px] sm:text-xs font-bold text-gray-600 mt-0.5">Código: FT-AI-01 | Versión: 01 | Alcance: Tesorería y Cajas</p>
            </div>
          </div>
          <div className="flex items-center gap-3 w-full sm:w-auto">
            <div className="text-right hidden sm:block mr-2">
              <p className="text-[10px] uppercase font-bold text-gray-500">Puntaje</p>
              <p className={`text-lg font-black leading-none ${score.porcentaje >= 80 ? 'text-emerald-600' : 'text-red-600'}`}>{score.porcentaje}%</p>
            </div>
            <button onClick={onBack} type="button" className="px-5 py-2.5 rounded-full bg-white/60 hover:bg-white text-gray-800 text-xs font-bold transition-all border border-gray-200 shadow-sm w-full sm:w-auto cursor-pointer hover:-translate-y-0.5">Cerrar Formulario</button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          
          <div className="bg-white/40 backdrop-blur-xl p-6 rounded-3xl border border-white/70 shadow-sm">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center border-b-2 border-blue-200/50 pb-3 mb-5 gap-4">
              <h3 className="text-xs font-extrabold text-gray-900 border-l-4 border-blue-600 pl-2 uppercase tracking-wider shrink-0">Información General</h3>
              <button type="button" onClick={() => setModalConfirmacion(true)} className="w-auto shrink-0 px-4 py-2 bg-emerald-50 hover:bg-emerald-100 text-emerald-700 text-[10px] font-black uppercase tracking-wider rounded-xl border border-emerald-200 shadow-sm transition-all flex items-center justify-center gap-1.5 cursor-pointer hover:scale-105">
                Llenado Rápido (CUMPLE)
              </button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              <div className="flex flex-col space-y-1.5"><label className="text-[10px] font-black text-gray-600 uppercase tracking-wide">Fecha</label><input type="date" name="fecha" value={headerData.fecha} onChange={handleHeaderChange} className={inputClass} required /></div>
              
              <div className="flex flex-col space-y-1.5">
                <label className="text-[10px] font-black text-gray-600 uppercase tracking-wide">Tipo Auditoría</label>
                <div className="relative w-full h-10">
                  <select name="tipo" value={headerData.tipo} onChange={handleHeaderChange} className={`${inputClass} appearance-none pr-8 cursor-pointer h-full absolute inset-0`}><option value="Programada">Programada</option><option value="No Programada">No Programada</option></select>
                  <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-500 text-[10px] font-black">▼</div>
                </div>
              </div>

              <div className="flex flex-col space-y-1.5">
                <label className="text-[10px] font-black text-gray-600 uppercase tracking-wide">Punto de Venta / Sede *</label>
                <div className="relative w-full h-10">
                  <select name="puntoVenta" value={headerData.puntoVenta} onChange={handleHeaderChange} className={`${inputClass} appearance-none pr-8 cursor-pointer h-full absolute inset-0`} required>
                    <option value="" disabled>Seleccione sede...</option>
                    {sedesDisponibles.map(s => <option key={s.id} value={s.nombre}>{s.nombre}</option>)}
                  </select>
                  <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-500 text-[10px] font-black">▼</div>
                </div>
              </div>

              <div className="flex flex-col space-y-1.5"><label className="text-[10px] font-black text-gray-600 uppercase tracking-wide">Auditor</label><input type="text" value={auditorNombre} readOnly className={`${inputClass} bg-gray-100 text-gray-500 cursor-not-allowed`} /></div>
              <div className="flex flex-col space-y-1.5"><label className="text-[10px] font-black text-gray-600 uppercase tracking-wide">Admin. de PDV</label><input type="text" name="adminPDV" value={headerData.adminPDV} onChange={handleHeaderChange} className={inputClass} required /></div>
              <div className="flex flex-col space-y-1.5"><label className="text-[10px] font-black text-gray-600 uppercase tracking-wide">Coord. Administrativo</label><input type="text" name="coordAdmin" value={headerData.coordAdmin} onChange={handleHeaderChange} className={inputClass} required /></div>
              <div className="flex flex-col space-y-1.5"><label className="text-[10px] font-black text-gray-600 uppercase tracking-wide">Hora Inicio</label><input type="time" name="horaInicio" value={headerData.horaInicio} onChange={handleHeaderChange} className={inputClass} required /></div>
              <div className="flex flex-col space-y-1.5"><label className="text-[10px] font-black text-gray-600 uppercase tracking-wide">Hora Fin</label><input type="time" name="horaFin" value={headerData.horaFin} onChange={handleHeaderChange} className={inputClass} required /></div>
            </div>
          </div>

          {COMPONENTES_AUDITORIA.map((comp, idx) => (
            <div key={idx} className="bg-white/40 backdrop-blur-xl border border-white/70 rounded-3xl overflow-hidden shadow-sm">
              <div className="bg-slate-900/80 p-3.5 border-b border-gray-900/10 text-white">
                <h3 className="font-extrabold text-sm uppercase tracking-wide">{comp.nombre}</h3>
              </div>
              <div className="divide-y divide-gray-200/50">
                {comp.items.map((item) => {
                  const r = respuestas[item.n] || {};
                  const isHallazgo = r.resultado === "NO CUMPLE";
                  return (
                    <div key={item.n} className={`p-4 sm:p-5 transition-colors ${isHallazgo ? 'bg-red-50/40' : 'hover:bg-white/60'}`}>
                      <div className="flex flex-col lg:flex-row gap-4 lg:items-start">
                        <div className="flex-1">
                          <div className="flex gap-3 items-start">
                            <span className="w-6 h-6 rounded-full bg-blue-100 text-blue-700 flex items-center justify-center text-[10px] font-black shrink-0 mt-0.5">{item.n}</span>
                            <div>
                              <p className="text-xs font-bold text-gray-900 leading-snug">{item.criterio}</p>
                              <p className="text-[10px] font-medium text-gray-500 mt-1 uppercase">📑 Soporte: {item.evidencia}</p>
                            </div>
                          </div>
                        </div>

                        <div className="flex bg-white/70 p-1.5 rounded-xl border border-gray-200 shadow-inner w-fit self-end lg:self-auto shrink-0">
                          {[
                            { val: "CUMPLE", color: "bg-emerald-600 text-white border-transparent" },
                            { val: "NO CUMPLE", color: "bg-red-600 text-white border-transparent" },
                            { val: "N/A", color: "bg-gray-600 text-white border-transparent" }
                          ].map(opt => (
                            <button
                              key={opt.val} type="button"
                              onClick={() => handleRespuestaChange(item.n, "resultado", opt.val)}
                              className={`px-3 py-2 text-[9px] font-black rounded-lg transition-all cursor-pointer uppercase ${
                                r.resultado === opt.val ? `${opt.color} shadow-md` : 'text-gray-500 hover:bg-gray-100'
                              }`}
                            >
                              {opt.val}
                            </button>
                          ))}
                        </div>
                      </div>

                      <div className="mt-3 pl-0 lg:pl-9 flex flex-col lg:flex-row gap-3 items-center animate-fade-in">
                        <input 
                          type="text" placeholder="Observación / Hallazgo..." 
                          value={r.observacion || ""} onChange={(e) => handleRespuestaChange(item.n, "observacion", e.target.value)}
                          className="w-full lg:flex-1 h-[38px] px-3 border border-gray-200 rounded-xl text-[11px] font-medium bg-white/80 focus:border-blue-400 focus:outline-none shadow-inner box-border" 
                        />
                        {isHallazgo && (
                          <>
                            <div className="w-full lg:w-40 relative shrink-0">
                              <select 
                                value={r.riesgo || ""} onChange={(e) => handleRespuestaChange(item.n, "riesgo", e.target.value)} 
                                className="w-full h-[38px] px-3 appearance-none border border-red-200 rounded-xl text-[11px] font-bold bg-red-50 text-red-900 outline-none shadow-inner cursor-pointer box-border"
                              >
                                <option value="">Nivel Riesgo...</option>
                                <option value="ALTO">⚠️ ALTO</option>
                                <option value="MEDIO">🔸 MEDIO</option>
                                <option value="BAJO">🔹 BAJO</option>
                              </select>
                              <div className="absolute right-3 top-[12px] pointer-events-none text-red-700 text-[10px] font-black">▼</div>
                            </div>
                            <input 
                              type="text" placeholder="Responsable Mejora" 
                              value={r.responsable || ""} onChange={(e) => handleRespuestaChange(item.n, "responsable", e.target.value)}
                              className="w-full lg:w-48 h-[38px] px-3 border border-red-200 rounded-xl text-[11px] font-bold bg-red-50 text-red-900 outline-none shadow-inner shrink-0 box-border" 
                            />
                          </>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}

          {/* FIRMAS Y ENVÍO (Incluye firma del Admin de Punto) */}
          <div className="bg-white/40 backdrop-blur-xl p-6 rounded-3xl border border-white/70 shadow-sm grid grid-cols-1 md:grid-cols-2 gap-6">
            
            {/* Firma Auditor */}
            <div className="bg-white/60 p-5 rounded-2xl border border-white/80 shadow-sm">
              <label className="block text-xs font-black mb-2 uppercase text-gray-900 border-l-4 border-blue-600 pl-2">Firma del Auditor *</label>
              <div className="border-2 border-dashed border-blue-300/80 rounded-2xl bg-white overflow-hidden relative shadow-inner mb-3">
                <SignatureCanvas ref={firmaRef} penColor="black" canvasProps={{ className: "w-full h-32 cursor-crosshair touch-none" }} />
                <button type="button" onClick={() => limpiarFirma(firmaRef)} className="absolute top-2 right-2 px-3 py-1 bg-red-100 hover:bg-red-200 text-red-700 rounded-lg text-[9px] font-bold shadow-sm cursor-pointer transition-colors">Limpiar</button>
              </div>
              <p className="text-[11px] font-extrabold text-gray-900 text-center uppercase">{auditorNombre}</p>
            </div>

            {/* Firma Administrador de Punto */}
            <div className="bg-white/60 p-5 rounded-2xl border border-white/80 shadow-sm">
              <label className="block text-xs font-black mb-2 uppercase text-gray-900 border-l-4 border-purple-600 pl-2">Firma Admin. de Punto *</label>
              <div className="border-2 border-dashed border-purple-300/80 rounded-2xl bg-white overflow-hidden relative shadow-inner mb-3">
                <SignatureCanvas ref={firmaAdminRef} penColor="black" canvasProps={{ className: "w-full h-32 cursor-crosshair touch-none" }} />
                <button type="button" onClick={() => limpiarFirma(firmaAdminRef)} className="absolute top-2 right-2 px-3 py-1 bg-red-100 hover:bg-red-200 text-red-700 rounded-lg text-[9px] font-bold shadow-sm cursor-pointer transition-colors">Limpiar</button>
              </div>
              <p className="text-[11px] font-extrabold text-gray-900 text-center uppercase">{headerData.adminPDV || "Administrador de Punto"}</p>
            </div>

            <div className="md:col-span-2 flex flex-col justify-center gap-4 mt-2">
              <div className="bg-slate-900/80 rounded-2xl p-4 text-white text-center shadow-inner">
                <p className="text-[10px] font-black uppercase text-gray-400 mb-1">Resultado de Auditoría</p>
                <div className="flex justify-around items-center mt-2">
                  <div><p className="text-xl font-black text-emerald-400">{score.cumple}</p><p className="text-[9px] uppercase">Cumple</p></div>
                  <div><p className="text-xl font-black text-red-400">{score.noCumple}</p><p className="text-[9px] uppercase">No Cumple</p></div>
                  <div><p className="text-xl font-black">{score.porcentaje}%</p><p className="text-[9px] uppercase">Puntaje</p></div>
                </div>
              </div>
              
              <button type="submit" disabled={guardando} className={`w-full py-4 rounded-2xl text-sm font-black text-white shadow-[0_4px_14px_rgba(0,122,255,0.3)] transition transform hover:-translate-y-0.5 cursor-pointer uppercase tracking-wider ${guardando ? "bg-blue-400 cursor-not-allowed" : "bg-[#007aff] hover:bg-[#0062cc]"}`}>
                {guardando ? "Guardando Auditoría..." : "Terminar y Guardar"}
              </button>
            </div>

          </div>

        </form>
      </div>
    </div>
  );
}